import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {SummaryRoutingModule} from "./summary-routing.module";
import {GlobalModule} from "../global/global.module";
import {AngularSignaturePadModule} from "@almothafar/angular-signature-pad";
import {SummaryComponent} from "./summary.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SummaryRoutingModule,
    GlobalModule,
    AngularSignaturePadModule,
  ],
  declarations: [
    SummaryComponent
  ]
})
export class SummaryModule {

}
